import { render, staticRenderFns } from "./PreOrderTrips.vue?vue&type=template&id=0ddf64d3&scoped=true&"
import script from "./PreOrderTrips.vue?vue&type=script&lang=js&"
export * from "./PreOrderTrips.vue?vue&type=script&lang=js&"
import style0 from "./PreOrderTrips.vue?vue&type=style&index=0&id=0ddf64d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddf64d3",
  null
  
)

export default component.exports